<template>
  <v-card>
    <v-toolbar dense flat color="primary" dark>
      <v-toolbar-title>渠道详情</v-toolbar-title>
    </v-toolbar>
    <v-container v-if="loading" class="text-center">
      <v-progress-circular class="text-center mx-auto" color="primary" indeterminate/>
    </v-container>
    <div v-else>
      <v-container v-if="channels.length === 0" class="text-center">
        <v-btn color="primary" text @click="addChannel(channels)">
          <v-icon>mdi-plus</v-icon>
          新增渠道
        </v-btn>
      </v-container>
      <v-form v-else ref="form" lazy-validation>
        <v-card-text>
          <v-row v-for="(provider, index) of providers" :key="'provider' + index">
            <v-col>
              <v-text-field label="供应商名称" v-model="provider.providerName"
                            :rules="rules.required"
                            append-outer-icon="mdi-minus"
                            :append-icon="index === channels.length - 1 ? 'mdi-plus' : ''"
                            @click:append="addProvider" @click:append-outer="removeProvider(index)"
                            @click:prepend="channel.open = !channel.open"/>
            </v-col>
          </v-row>
          <div v-for="(channel, index) of channels" :key="channel.channelName">
            <v-row>
              <v-col>
                <v-text-field label="渠道名称" v-model="channel.channelName"
                              :rules="rules.required"
                              :prepend-icon="channel.open ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                              append-outer-icon="mdi-minus"
                              :append-icon="index === channels.length - 1 ? 'mdi-plus' : ''"
                              @click:append="addChannel(channels)" @click:append-outer="removeChannel(channels, index)"
                              @click:prepend="channel.open = !channel.open"/>
              </v-col>
            </v-row>
            <div v-for="(channelType, typeIndex) of channel.channelTypes"
                 :key="channelType.channelName + '-channelType' + typeIndex"
                 :style="channel.open ? '' : 'display: none'">
              <v-row align="center">
                <v-col cols="2">
                  <v-divider/>
                </v-col>
                <v-col>
                  <v-text-field label="渠道类型" v-model="channelType.channelType"
                                :rules="rules.required"
                                :prepend-icon="channelType.open ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                                append-outer-icon="mdi-minus"
                                :append-icon="typeIndex === channel.channelTypes.length - 1 ? 'mdi-plus' : ''"
                                @click:append="addChannelType(channel.channelTypes)"
                                @click:append-outer="removeChannelType(channel.channelTypes, typeIndex)"
                                @click:prepend="channelType.open = !channelType.open"/>
                </v-col>
              </v-row>
              <div v-for="(repository, repoIndex) of channelType.repositories"
                   :key="channelType.channelName + '-channelType' + typeIndex + '-repository' + repoIndex"
                   :style="channelType.open ? '' : 'display: none'">
                <v-row align="center">
                  <v-col cols="4">
                    <v-divider/>
                  </v-col>
                  <v-col>
                    <v-text-field label="仓库" v-model="repository.repository"
                                  :rules="rules.required"
                                  :prepend-icon="repository.open ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                                  append-outer-icon="mdi-minus"
                                  :append-icon="repoIndex === channelType.repositories.length - 1 ? 'mdi-plus' : ''"
                                  @click:append="addRepository(channelType.repositories)"
                                  @click:append-outer="removeRepository(channelType.repositories, repoIndex)"
                                  @click:prepend="repository.open = !repository.open"/>
                  </v-col>
                </v-row>
                <div v-for="(limit, limitIndex) of repository.limits"
                     :key="channelType.channelName + '-channelType' + typeIndex + '-repository' + repoIndex + '-limit' + limitIndex"
                     :style="repository.open ? '' : 'display: none'">
                  <v-row align="center">
                    <v-col cols="6">
                      <v-divider/>
                    </v-col>
                    <v-col>
                      <v-select placeholder="类型" :items="limitTypes" v-model="limit.priceType"/>
                    </v-col>
                    <v-col>
                      <v-text-field :label="limit.priceType === 1 ? '最小重量' : '最小体积'" v-model="limit.minLimit"
                                    :rules="rules.required"
                                    append-outer-icon="mdi-minus" :suffix="limit.priceType === 1 ? 'KG' : 'CBM'"
                                    :append-icon="limitIndex === repository.limits.length - 1 ? 'mdi-plus' : ''"
                                    @click:append="addLimit(repository.limits)"
                                    @click:append-outer="removeLimit(repository.limits, limitIndex)"/>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" small @click="save">保存</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-form>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ChannelDetailCard",
  props: {
    channel: Object
  },
  data() {
    return {
      loading: false,
      limitTypes: [
        {value: 1, text: '重量'},
        {value: 2, text: '体积'}
      ],
      providers: [
        {providerName: null}
      ],
      channels: [],
      rules: {
        required: [
          v => !!v || '此项必填!'
        ]
      }
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.$axios.get("/channels/group", {params: {'country': this.channel.name}}).then(
          res => {
            this.channels = res.data
            this.loading = false
          }
      )
    },
    getProviders() {

    },
    addProvider() {
      this.providers.push({providerName: null})
    },
    removeProvider(index) {
      this.providers.splice(index, 1)
    },
    addChannel(channels) {
      let channel = {open: true, channelName: null, channelTypes: []}
      this.addChannelType(channel.channelTypes)
      channels.push(channel)
    },
    removeChannel(channels, index) {
      channels.splice(index, 1)
    },
    addChannelType(channelTypes) {
      let channelType = {open: true, channelType: null, repositories: []}
      this.addRepository(channelType.repositories)
      channelTypes.push(channelType)
    },
    removeChannelType(channelTypes, index) {
      if (channelTypes.length <= 1) {
        this.$bus.$emit('msg', "至少需要一个渠道类型!")
      } else {
        channelTypes.splice(index, 1)
      }
    },
    addRepository(repositories) {
      let repository = {open: true, repository: null, limits: []}
      this.addLimit(repository.limits)
      repositories.push(repository)
    },
    removeRepository(repositories, index) {
      if (repositories.length <= 1) {
        this.$bus.$emit('msg', "至少需要一个仓库!")
      } else {
        repositories.splice(index, 1)
      }
    },
    addLimit(limits) {
      limits.push({
        priceType: 1,
        minLimit: null
      })
    },
    removeLimit(limits, index) {
      if (limits.length <= 1) {
        this.$bus.$emit('msg', "至少需要一个重量或体积!")
      } else {
        limits.splice(index, 1)
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        console.log(123)
      }
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>

</style>